import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { TransformationSection } from './components/TransformationSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AuthoritySection } from './components/AuthoritySection';
import { ReviewsSection } from './components/ReviewsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { LegacySection } from './components/LegacySection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28tw972nrl48q">
      <AnnouncementBar data-id="element-1" data-mp="28s31dk1f0dz5" />
      <main data-id="element-2" data-mp="23vuq4hqc94x9">
        <Hero data-id="element-3" data-mp="23u9t8lgjx9w8" />
        <PainSection data-id="element-4" data-mp="23ujl6el5pr4k" />
        <SolutionSection data-id="element-5" data-mp="23t8hsfvmildz" />
        <TransformationSection data-id="element-6" data-mp="3ijxsv0nzqion" />
        <WhatYouGetSection data-id="element-7" data-mp="3iiweonbohg2p" />
        <ReviewsSection data-id="element-8" data-mp="3ijpc2xoqyt86" />
        <OfferSection data-id="element-9" data-mp="3mlja0y7k5j4n" />
        <AuthoritySection data-id="element-10" data-mp="3ml12v6jcxkhy" />
        <ForWhoSection data-id="element-11" data-mp="3mk852v2dm5by" />
        <FaqSection data-id="element-12" data-mp="3mjg9vlcoy9m7" />
        <LegacySection data-id="element-13" data-mp="3rc9e8848zfxr" />
      </main>
      <Footer data-id="element-14" data-mp="3rdaquh0wwahl" />
    </div>;
}